export const light = {
  'header/linkColorHover': '#222',
  'header/boxShadowColor': '#f0f0f0',
  'header/searchIconColor': '#969696',
  'header/searchIconFocusBg': '#969696',
  'header/searchIconFocusColor': '#fff',
  'header/searchColor': '#777',
  'header/searchBg': '#eee',
  'header/btnWriteBg': '#bbb',
  'header/btnWriteHoverBg': '#666',
  'header/btnRegColor': '#666',
  'header/btnRegBorder': '#bbb',
  'header/btnRegHoverBorder': '#555',
  'header/btnLoginColor': '#555',
  'header/btnLoginHoverColor': '#222',
  'header/btnIconColor': '#fff',
  'header/avatarHoverBg': '#f5f5f5'
}
export const dark = {
  'header/linkColorHover': '#f9f9f9',
  'header/boxShadowColor': '#414141',
  'header/searchIconColor': '#fff',
  'header/searchIconFocusBg': '#23252c',
  'header/searchIconFocusColor': '#fff',
  'header/searchColor': '#eaeaeb',
  'header/searchBg': '#17181d',
  'header/btnWriteBg': '#ccc',
  'header/btnWriteHoverBg': '#fff',
  'header/btnRegColor': '#eaeaeb',
  'header/btnRegBorder': '#bbb',
  'header/btnRegHoverBorder': '#fff',
  'header/btnLoginColor': '#eaeaeb',
  'header/btnLoginHoverColor': '#fff',
  'header/btnIconColor': '#eaeaeb',
  'header/avatarHoverBg': '#27282e'
}
